import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message, Checkbox } from 'semantic-ui-react'
import ColorPicker from '../ColorPicker';
import Moment from 'moment';
import {convertNullToEmptyString, normalizeNumber, optionsCommessePeso, optionsCommesseInRendicontazione} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import PropTypes from 'prop-types';
import RubricaSearchModal from "../rubrica/RubricaSearchModal";

class CommesseForm extends Component {
    constructor(props) {
        super(props);

        let idGara = undefined;
        if(props.location.state){
            idGara = props.location.state.idGara;
        }

        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
            idGara: idGara,
            inUpdate: this.props.match.params.id !== undefined,
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            cancelSuccess: false,
            error: null,
            itemSaved: null,
        };

        this.setFieldsFromGara = this.setFieldsFromGara.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.onSelectSoggetto = this.onSelectSoggetto.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
    }

    isLoadingInProgress(){
        return this.state._loading;
    }
    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadCommessa(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((commessa) => {
                            
                            let fields = convertNullToEmptyString(commessa);
                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null, itemSaved: commessa});
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
        else {
            if (this.state.idGara){
                this.setFieldsFromGara(this.state.idGara);
            }
        }
    }

    setFieldsFromGara(idGara){
        this.setState({ _loading: true });
        client.loadGara(idGara).then(
            (response) => {
                if (response.ok){
                    response.json().then((gara) => {
                        let ora = Moment().format("YYYY-MM-DD");
                        let fieldsGara = convertNullToEmptyString(gara);
                        let fields = {
                            'codice': '',
                            'colore': '#FFFFFF',
                            'nome': fieldsGara.nome,
                            'dataIncarico': ora,
                            'dataInizioPrestazione': '',
                            'dataFinePrestazione' : '',
                            'dataChiusura' : '',
                            'ragioneSociale' : fieldsGara.ragioneSociale,
                            'indirizzo' : fieldsGara.indirizzo,
                            'cap' : fieldsGara.cap,
                            'citta' : fieldsGara.citta,
                            'provincia' : fieldsGara.provincia,
                            'stato' : fieldsGara.stato,
                            'piva' : fieldsGara.piva,
                            'cfisc' : fieldsGara.cfisc,
                            'email' : fieldsGara.email,
                            'pec' : fieldsGara.pec,
                            'web' : fieldsGara.web,
                            'fax' : fieldsGara.fax,
                            'telefono1' : fieldsGara.telefono1,
                            'telefono2' : fieldsGara.telefono2,
                            'cellulare' : fieldsGara.cellulare,
                            'letteraIncarico' : '',
                            'letteraPrivacy' : '',
                            'oggetto' : '',
                            'note' : '',
                            'conclusa': false,
                            'inRendicontazione': true,
                            'priorita' : 50,
                            'incassoPresunto' : 0,
                            'peso' : 1,
                            'codCup' : fieldsGara.codCup,
                            'codDestUnivoco' : fieldsGara.codDestUnivoco,

                        };
                        this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                            fieldErrorsText: [], inError: false, error: null});
                        this.forceUpdate();
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        let fieldErrorsText = []
                        let fieldErrors = {}
                        this.setState({
                            _loading: false,
                            fieldErrors: fieldErrors,
                            fieldErrorsText: fieldErrorsText,
                            errorTitle: '',
                            error: {title: errore.title, msg: errore.msg},
                            inError: true
                        });
                    });

                }
            }).catch((error) => {

            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                _loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });

        });
    }

    getEmptyFields() {
        let ora = Moment().format("YYYY-MM-DD");
        return {
            'codice': '',
            'colore': '#FFFFFF',
            'nome': '',
            'responsabile': '',
            'dataIncarico': ora,
            'dataInizioPrestazione': '',
            'dataFinePrestazione' : '',
            'dataChiusura' : '',
            'ragioneSociale' : '',
            'indirizzo' : '',
            'cap' : '',
            'citta' : '',
            'provincia' : '',
            'stato' : '',
            'piva' : '',
            'cfisc' : '',
            'email' : '',
            'pec' : '',
            'web' : '',
            'fax' : '',
            'telefono1' : '',
            'telefono2' : '',
            'cellulare' : '',
            'letteraIncarico' : '',
            'letteraPrivacy' : '',
            'oggetto' : '',
            'priorita' : 50,
            'incassoPresunto' : 0,
            'peso' : 1,
            'conclusa': false,
            'codCup' : '',
            'codDestUnivoco' : '',
            'inRendicontazione' : true,
            'oreLavoroPrev' : 0,
            'dataFinePrev' : ''
        }
    }

    onSelectSoggetto(soggetto){
        const fields = this.state.fields;

        const dip = soggetto.idDipartimento;
        const org = dip.idOrganizzazione;

        console.log("SOGG SEL: ", soggetto, dip, org);

        fields["idSoggetto"]=soggetto.idSoggetto;
        if(org.nome){
            fields["ragioneSociale"]= org.nome;
            fields["indirizzo"]=org.indirizzo;
            fields["stato"]=org.stato;
            fields["cap"]=org.cap;
            fields["citta"]=org.citta;
            fields["provincia"]=org.provincia;
            fields["piva"]=org.piva;
            fields["cfisc"]=org.cfisc;
            fields["fax"]=org.fax;
            fields["telefono1"]=org.telefono1;
            fields["telefono2"]=org.telefono2;
            fields["cellulare"]=org.cellulare;
            fields["email"]=org.email;
            fields["pec"]=org.pec;
            fields["web"]=org.web;
        }
        else {
            fields["ragioneSociale"]=  soggetto.nomeCognome;
            fields["indirizzo"]=soggetto.indirizzo;
            fields["stato"]=soggetto.stato;
            fields["cap"]=soggetto.cap;
            fields["citta"]=soggetto.citta;
            fields["provincia"]=soggetto.provincia;
            fields["piva"]=soggetto.piva;
            fields["cfisc"]=soggetto.cfisc;
            fields["fax"]=soggetto.fax;
            fields["telefono1"]=soggetto.telefono1;
            fields["telefono2"]=soggetto.telefono2;
            fields["cellulare"]=soggetto.cellulare;
            fields["email"]=soggetto.email;
            fields["pec"]=soggetto.pec;
            fields["web"]=soggetto.web;
        }
        this.setState({ fields });
    }


    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (formData.nome !== "")
        {
            if ( (/^[\w\- ]+$/.test(formData.nome)) === false ){
                fieldErrors["nome"] = true;
                fieldErrorsText.push("Nome della Commessa: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: '-', ' '.");
            }
        }
        // Validazione date
        if (formData.dataChiusura === "Invalid date"){
            fieldErrors["dataChiusura"] = true;
            fieldErrorsText.push("La data di chiusura non è nel formato corretto (gg/mm/aaaa)");
        }
        if (formData.dataIncarico === "Invalid date"){
            fieldErrors["dataIncarico"] = true;
            fieldErrorsText.push("La data di incarico non è nel formato corretto (gg/mm/aaaa)");
        }
        if (formData.dataInizioPrestazione === "Invalid date"){
            fieldErrors["dataInizioPrestazione"] = true;
            fieldErrorsText.push("La data di inizio prestazione non è nel formato corretto (gg/mm/aaaa)");
        }
        if (formData.dataFinePrestazione === "Invalid date"){
            fieldErrors["dataFinePrestazione"] = true;
            fieldErrorsText.push("La data di fine prestazione non è nel formato corretto (gg/mm/aaaa)");
        }
        if (formData.dataFinePrev === "Invalid date"){
            fieldErrors["dataFinePrev"] = true;
            fieldErrorsText.push("La data di fine prevista non è nel formato corretto (gg/mm/aaaa)");
        }

        if (formData.dataChiusura !== "" && formData.dataChiusura !== "Invalid date" )
        {
            // Deve essere successiva alle altre date
            if (formData.dataIncarico > formData.dataChiusura){
                fieldErrors["dataChiusura"] = true;
                fieldErrorsText.push("La data di chiusura deve essere successiva o uguale a quella di incarico");
            }
            if (formData.dataInizioPrestazione !== "" && formData.dataInizioPrestazione > formData.dataChiusura){
                fieldErrors["dataChiusura"] = true;
                fieldErrorsText.push("La data di chiusura deve essere successiva o uguale a quella di inizio prestazione");
            }
        }

        if (formData.dataFinePrestazione !== ""  && formData.dataFinePrestazione !== "Invalid date")
        {
            if (formData.dataInizioPrestazione !== "" && formData.dataInizioPrestazione > formData.dataFinePrestazione){
                fieldErrors["dataFinePrestazione"] = true;
                fieldErrorsText.push("La data di fine prestazione deve essere successiva o uguale a quella di inizio prestazione");
            }
        }

        if (formData.incassoPresunto !== "")
        {
            if (Number(formData.incassoPresunto) < 0 ){
                fieldErrors["incassoPresunto"] = true;
                fieldErrorsText.push("Incasso presunto: Indica un valore maggiore o uguale a zero");
            }
        }
        if (formData.oreLavoroPrev !== "")
        {
            if (Number(formData.oreLavoroPrev) < 0 ){
                fieldErrors["oreLavoroPrev"] = true;
                fieldErrorsText.push("Ore di lavoro previste: Indica un valore maggiore o uguale a zero");
            }
        }
        if (formData.priorita !== "")
        {
            if (Number(formData.priorita) < 0 || Number(formData.priorita) > 999 ){
                fieldErrors["priorita"] = true;
                fieldErrorsText.push("Priorità: Indica un valore compreso tra 0 e 999");
            }
        }


        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {

        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;
        formData["colore"] = this.state.fields["colore"];
        formData["incassoPresunto"] = normalizeNumber(formData["incassoPresunto"]);

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }


        // Salvataggio sul server
        delete formData["stato-search"];
        if(formData["idGara"]){
            formData["idGara"] = formData["idGara"]["idGara"];
        }
        this.setState({_loading: true});
        client.saveCommessa(
            formData,
            this.state.fields.idCommessa,
            this.state.idGara
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idCommessa"] = data.idCommessa;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio commessa",
                        successText: "La commessa è stata salvata correttamente",
                        fields: fields,
                        itemSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
        }
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = checked;
            this.setState({ fields });
        }
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    


    render() {
        
        let btnSalva = null;
        if (client.getCurrentUser().isrolecommessew){
            btnSalva = <div className="left aligned eight wide column">
                <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
            </div>
        }else{
            btnSalva = <div className="left aligned eight wide column">
                <Button secondary disabled type='submit'><i className="save icon"/>Non hai i diritti per salvare</Button>
            </div>

        }

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess  || this.state.cancelSuccess){

            return <Redirect to={ {
                pathname: '/app/commesse/list',
                state: {
                    from: this.props.location,
                    item: this.state.itemSaved
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Commessa - Informazioni di base</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuova Commessa - Informazioni di base</h3>


        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">

                <Form.Group widths="3">
                    <Form.Field width={2} label="Colore" required={true} control={ColorPicker} name="colore" value={this.state.fields.colore} onChange={this.onInputChange} />
                    <Form.Field width={2} label="Codice" required={true} control={Input} name='codice'  autoComplete="nope"  title="Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: meno (-) blank ( )" pattern="[A-Z0-9-]+"  placeholder='Codice' minLength='5' maxLength='5' value={this.state.fields.codice}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codice"]}/>
                    <Form.Field width={9} label="Nome" required={false} control={Input} name='nome' autoComplete="nope"  placeholder='Nome commessa' maxLength="100"  value={this.state.fields.nome}  onChange={this.onInputChange}/>
                    <Form.Field width={3} label="Responsabile" required={false} control={Input} name='responsabile' autoComplete="nope"  placeholder='Responsabile' maxLength="3"  value={this.state.fields.responsabile}  onChange={this.onInputChange}/>
                </Form.Group>
                    <em >Nome: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: meno (-) blank ( )</em>
                <Form.TextArea name='oggetto' label='Oggetto' placeholder='' rows='4' value={this.state.fields.oggetto} onChange={this.onInputChange}/>
                <Form.Group widths='6'>
                    <Form.Field width={4}>
                        <label>Incarico</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataIncarico', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataIncarico}
                        />
                    </Form.Field>
                    <Form.Field width={4}>
                        <label>Inizio Prestazione</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataInizioPrestazione', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataInizioPrestazione}
                        />
                    </Form.Field>
                    <Form.Field width={3}>
                        <label>Fine Prestazione</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataFinePrestazione', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataFinePrestazione}
                        />
                    </Form.Field>
                    <Form.Field width={3}>
                        <label>Chiusura</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataChiusura', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataChiusura}
                        />
                    </Form.Field>
                    <Form.Field width={2} >
                        <label>Prestazione conclusa</label>
                        <Checkbox name="conclusa" defaultIndeterminate={false} toggle checked={this.state.fields.conclusa} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                    <Form.Field width={2} >
                        <label>Commessa archiviata</label>
                        <Checkbox name="archiviata" defaultIndeterminate={false} toggle checked={this.state.fields.archiviata} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                <Form.Group widths="3">
                    <Form.Field width={5} label="Codice Destinatario / Codice Univoco (SDI/IPA)" required={false} disabled={false} control={Input} maxLength="7" name='codDestUnivoco'  autoComplete="nope"  title="Inserire solo lettere e/o numeri" pattern="[A-Z0-9]+"  placeholder='Codice'  value={this.state.fields.codDestUnivoco}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codDestUnivoco"]}/>
                    <Form.Field width={7} label="Codice Unico di Progetto (CUP)" required={false} disabled={false} control={Input} name='codCup' maxLength="15"  autoComplete="nope"  title="Inserire solo lettere e/o numeri" pattern="[A-Z0-9]+"  placeholder='Codice'  value={this.state.fields.codCup}  onChange={this.onInputChangeUppercase} error={this.state.fieldErrors["codCup"]}/>
                    
                    <Form.Field width={4} >
                        <Form.Dropdown label='Tipo di rendicontazione' name='inRendicontazione' fluid selection options={optionsCommesseInRendicontazione} value={''+this.state.fields.inRendicontazione} onChange={this.onInputChange}/>
                    </Form.Field>
                </Form.Group>

                </div>
                <h3 className="ui block attached header">Cliente &nbsp;
                    <small><RubricaSearchModal
                        title={"Importa dalla rubrica"}
                        onSelectSoggetto={this.onSelectSoggetto}
                    >
                        <a href={"#"}>Importa dalla rubrica</a>
                    </RubricaSearchModal></small>
                </h3>
                <div className="ui attached segment">
                <Form.Input label='Ragione sociale' required={false} name='ragioneSociale'  autoComplete="nope"  placeholder='Ragione sociale cliente' maxLength={255} value={this.state.fields.ragioneSociale} onChange={this.onInputChange}/>
                <Form.Input label='Indirizzo' name='indirizzo'  autoComplete="nope" placeholder='Via/Piazza...' maxLength={255} value={this.state.fields.indirizzo} onChange={this.onInputChange}/>
                <Form.Group widths='4'>
                    <Form.Input label='Stato' name='stato' placeholder='' autoComplete="nope"  width={1} maxLength={2} value={this.state.fields.stato} onChange={this.onInputChangeUppercase} />
                    <Form.Input label='CAP' name='cap'  autoComplete="nope" placeholder='' width={2} maxLength={10} value={this.state.fields.cap} onChange={this.onInputChange} />
                    <Form.Input label='Città' name='citta' autoComplete="nope"  placeholder='' width={11} maxLength={255} value={this.state.fields.citta} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Provincia' name='provincia'  autoComplete="nope" placeholder='' width={2} maxLength={2} value={this.state.fields.provincia} onChange={this.onInputChangeUppercase}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='P.IVA' name='piva' autoComplete="nope"  placeholder='' maxLength={11}  value={this.state.fields.piva} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Codice Fiscale' name='cfisc'  autoComplete="nope" placeholder='' maxLength={16}  value={this.state.fields.cfisc} onChange={this.onInputChangeUppercase}/>
                    <Form.Input label='Fax'  name='fax'  maxLength={30} autoComplete="nope" value={this.state.fields.fax} error={this.state.fieldErrors["fax"]} onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='Telefono 1' name='telefono1' autoComplete="nope"  placeholder='' maxLength={30}  value={this.state.fields.telefono1} error={this.state.fieldErrors["telefono1"]} onChange={this.onInputChange}/>
                    <Form.Input label='Telefono 2' name='telefono2'  autoComplete="nope" placeholder='' maxLength={30}  value={this.state.fields.telefono2} error={this.state.fieldErrors["telefono2"]} onChange={this.onInputChange}/>
                    <Form.Input label='Cellulare'  name='cellulare'  maxLength={30} autoComplete="nope" value={this.state.fields.cellulare} error={this.state.fieldErrors["cellulare"]} onChange={this.onInputChange}/>
                </Form.Group>
                <Form.Group widths='3'>
                    <Form.Input label='Email'  name='email'  autoComplete="nope" width={6} value={this.state.fields.email} error={this.state.fieldErrors["email"]} onChange={this.onInputChange}/>
                    <Form.Input label='PEC'  name='pec' autoComplete="nope" width={4} value={this.state.fields.pec} error={this.state.fieldErrors["pec"]} onChange={this.onInputChange}/>
                    <Form.Input label='Sito web' name='web'  autoComplete="nope" width={10} value={this.state.fields.web} error={this.state.fieldErrors["web"]} onChange={this.onInputChange}/>
                </Form.Group>
                </div>
                <h3 className="ui block attached header">Configurazione avanzata</h3>
                <div className="ui attached segment">
                <Form.Group widths='3'>
                    <Form.Input label='Priorità' name='priorita' min="0" max="999" pattern="^[0-9]+$" maxLength={3} placeholder='0/999'  value={this.state.fields.priorita} onChange={this.onInputChange}/>
                    <Form.Input label='Incasso presunto' name='incassoPresunto' pattern="^[0-9]*([.|,][0-9]{1,2}){0,1}$" required={true}  value={this.state.fields.incassoPresunto} error={this.state.fieldErrors["incassoPresunto"]} onChange={this.onInputChange}/>
                    <Form.Dropdown label='Peso' name='peso' fluid selection options={optionsCommessePeso} value={''+this.state.fields.peso} onChange={this.onInputChange}/>

                    <Form.Field width={3}>
                        <label>Data di fine prevista</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataFinePrev', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataFinePrev}
                        />
                    </Form.Field>

                    <Form.Input label='Ore di lavoro previste' name='oreLavoroPrev' min="0"  pattern="^[0-9]+$"  placeholder='0 o più ore'  value={this.state.fields.oreLavoroPrev} onChange={this.onInputChange}/>
                </Form.Group>
                    <Form.TextArea name='note' label='Note estese' placeholder='' rows='4' value={this.state.fields.note} onChange={this.onInputChange}/>
                </div>
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
            </div>
        )
    }
}

CommesseForm.contextTypes = {
    router: PropTypes.object
}

export default CommesseForm;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseForm.js
 **/